import { render, staticRenderFns } from "./ImageLoader.vue?vue&type=template&id=16bfd24f&scoped=true&lang=true"
import script from "./ImageLoader.vue?vue&type=script&lang=js"
export * from "./ImageLoader.vue?vue&type=script&lang=js"
import style0 from "./ImageLoader.vue?vue&type=style&index=0&id=16bfd24f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16bfd24f",
  null
  
)

export default component.exports